"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const isNil_1 = __importDefault(require("lodash/isNil"));
// Inspired by https://sage.amazon.com/questions/585958#607688
class PolarisFormik extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.handleBlur = (setFieldValue, setFieldTouched) => (e) => {
            if (e && e.target && e.detail) {
                // Selects do not have a name property. Neither do radio groups :(
                const name = e.target.component.__properties.name ||
                    e.target.component.__properties.controlId ||
                    e.target.id;
                // Selects use selectedId, checkboxes use checked
                const value = e.detail.value || e.detail.selectedId || e.detail.checked;
                setFieldValue(name, value);
                setFieldTouched(name);
            }
            else if (e && e.target && e.target.files) {
                // Support raw file input, as there is no Polaris component yet
                const name = e.target.name;
                setFieldValue(name, e.target.files);
                setFieldTouched(name);
            }
        };
        this.handleChange = (setFieldValue) => (e) => {
            if (e && e.target && e.detail) {
                // Selects do not have a name property. Neither do radio groups :(
                const name = e.target.component.__properties.name ||
                    e.target.component.__properties.controlId ||
                    e.target.id;
                // Selects use selectedId, checkboxes use checked.  Unfortunately,
                // using coalescing with || does not work, because it swallows 0's
                // and empty strings.
                let value = e.detail.value;
                if (isNil_1.default(value)) {
                    value = e.detail.selectedIds; // Support multi-select, which has both selectedId and selectedIds in its change event
                    if (isNil_1.default(value)) {
                        value = e.detail.selectedId;
                        if (isNil_1.default(value)) {
                            value = e.detail.checked;
                        }
                    }
                }
                setFieldValue(name, value);
            }
            else if (e && e.target && e.target.files) {
                // Support raw file input, as there is no Polaris component yet
                const name = e.target.name;
                setFieldValue(name, e.target.files);
            }
        };
        this.renderForm = ({ setFieldValue, setFieldTouched, ...props }) => {
            const { render } = this.props;
            return (render &&
                render({
                    ...props,
                    setFieldValue,
                    setFieldTouched,
                    handleChange: this.handleChange(setFieldValue),
                    handleBlur: this.handleBlur(setFieldValue, setFieldTouched),
                }));
        };
    }
    render() {
        return react_1.default.createElement(formik_1.Formik, Object.assign({}, this.props, { render: this.renderForm }));
    }
}
exports.default = PolarisFormik;
//# sourceMappingURL=PolarisFormik.js.map